/* eslint-disable react/forbid-prop-types */
import React, { useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { ScenarioContext } from '@bingads-webui-react/instrumentation-context';

export const withScenarioContext = (WrappedComponent) => {
  const HoC = (props) => {
    const context = useContext(ScenarioContext);

    return (<WrappedComponent
      {...props}
      scenario={context}
    />);
  };

  HoC.displayName = `withScenarioContext(${getDisplayName(WrappedComponent)})`;

  return hoistNonReactStatics(HoC, WrappedComponent);
};
